import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import fieldNames from './filenameTemplateFields';


const FileFormatConfiguration = ({
  filenameTemplate,
  removeField,
  edit,
  editable,
  save,
  clear,
}) => {
  const { selectedFileFormatFields } = filenameTemplate;

  const fieldPreviews = selectedFileFormatFields.map((field, idx) => {
    const foundField = _.find(fieldNames, { name: field });
    return (
      <span key={`pf2-${field}-${idx}`} className="preview-field">
        { foundField && foundField.preview ? foundField.preview(filenameTemplate) : field }
      </span>
    );
  });

  const preview = (fieldPreviews.length > 0)
    ? fieldPreviews.concat((<span className="preview-field">.pdf</span>))
    : fieldPreviews;

  const hiddenCls = editable ? '' : 'hidden';

  return (
    <div className="configuration-box file-format-configuration">
      <div className="right-panel-element">
        <div className="label">
          File Format Configuration
          <Button bsSize="xsmall" bsStyle="success" className="edit-btn" onClick={edit}>Edit</Button>
        </div>
        <div className={`field-container ${hiddenCls}`}>
          <div className="fields">
            { selectedFileFormatFields.map((field, idx) => (
              <div key={`selectedf-${field}-${idx}`}
                   className="field selected-field"
                   onClick={() => removeField(idx)}>
                <div>{field === ' ' ? '[space]' : field}</div>
                <span className="close-marker">X</span>
              </div>
            ))}
          </div>
        </div>
        <div className={`action-buttons ${hiddenCls}`}>
          <div>
            <Button bsSize="small" bsStyle="warning" className="clear-btn" onClick={clear}>Clear</Button>
            <Button bsSize="small" bsStyle="primary" className="save-btn" onClick={save}>Save</Button>
          </div>
        </div>
        <div className={`preview-panel ${hiddenCls}`}>
          <div className="label">File Format Preview</div>
          { preview }
        </div>
      </div>
    </div>
  );
};

FileFormatConfiguration.defaultProps = {
  editable: false,
};

FileFormatConfiguration.propTypes = {
  filenameTemplate: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  removeField: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  edit: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
};

export default FileFormatConfiguration;



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/FileFormatConfiguration.jsx